import * as React from 'react';
import { WhiteLabelMobileCarrierSection, WhiteLabelMobileButton, Checkbox } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { QuestionnaireEvaluationQuestionType } from "../../questionnaireEvaluation";
import { APPLICATION_CONTENT, BrandedNotificationWorkflowSubTypes, BrandedNotificationWorkflowTypes, NONE } from "../../brandedNotification";
import { PhotoCaptureAttributeType, PhotoCapture, PhotoCaptureAssignmentTypes } from '../enums';
import { PhotoCaptureConstants, PhotoCaptureScriptQuestionIds, DISABLE_DEVICE_LIBRARY_WARNING } from '../constants';
import { isDeviceLibraryDisabled } from '../utilities';
import { Content, CustomStyledCheckbox, CustomStyleAcknowledgeSection, CustomStyledActionControlsSection, DeclineStyledDiv, LinkButton, LinkContainer, CarrierSectionContainer } from './ScriptQuestionComponent.style';
import { PhotoCaptureNavigationControlComponent } from './PhotoCaptureNavigationControlComponent';
import { PhotoCaptureFraudWarningModal } from './PhotoCaptureFraudWarningModal';
export const ScriptQuestionComponent = (props) => {
    const { questionText, questionSubType, appTheme, languages, onLanguageChange, isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, isContextUpdated, contextId, isTermsAndConditionAccepted, warningMessage, pbeAsgTaskId, fraudStatement, fraudWarningAccept, language, assignmentType, isFraudWarningApiStatus, disableLibrary, photoCaptureAttachmentInfo, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction, photoCaptureUpdateTncAction, photoCaptureGetFraudWarningDataAction, photoCaptureUpdateFraudWarningAcceptAction, getConfigurationDataAction } = props;
    const { buttonBackgroundColor, buttonTextColor, disabledButtonBackgroundColor, disabledButtonTextColor } = appTheme;
    const [isTNCAccepted, setIsTNCAccepted] = React.useState(isTermsAndConditionAccepted);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [fraudWarningAccepted, setFraudWarningAccepted] = React.useState(fraudWarningAccept);
    const translateFn = TranslationService.translate;
    const shouldLanguageDropdownDisplay = questionSubType === PhotoCaptureAttributeType.DEFAULT;
    const btnLabel = shouldLanguageDropdownDisplay
        ? translateFn(PhotoCaptureConstants.GET_STARTED)
        : translateFn(PhotoCaptureConstants.BACK);
    const isDeviceLibDisabled = shouldLanguageDropdownDisplay && isDeviceLibraryDisabled(disableLibrary);
    const onChange = (configureLanguage) => {
        onLanguageChange && onLanguageChange(configureLanguage);
        const brandedNotificationInputs = {
            notificationLanguage: configureLanguage || '',
            workflowType: BrandedNotificationWorkflowTypes.PHOTO_CAPTURE,
            workflowSubType: BrandedNotificationWorkflowSubTypes.APPLICATION,
            notificationType: NONE,
            underWritingCompany: '',
            contentType: APPLICATION_CONTENT
        };
        getConfigurationDataAction(brandedNotificationInputs, companyCode, '');
        evaluationDocId &&
            questionnaireId &&
            changeQuestion(evaluationDocId, questionnaireId, 0, QuestionnaireEvaluationQuestionType.FIRST);
    };
    const WhiteLabelMobileCarrierSectionProps = {
        onChange: onChange,
        headerText: appTheme.headerText,
        headerBackgroundColor: appTheme.headerBackgroundColor,
        headerColor: appTheme.headerColor,
        speechBoxRichText: questionText,
        speechBoxBackgroundColor: appTheme.speechBoxBackgroundColor,
        avatarUrl: appTheme.avatarUrl,
        avatarColor: appTheme.avatarColor,
        languageOptions: languages,
        languageFontSize: appTheme.languageFontSize,
        languageFontColor: appTheme.languageFontColor,
        languageGlobeColor: appTheme.languageGlobeColor,
        islanguageHide: !shouldLanguageDropdownDisplay,
        warningMessage: isDeviceLibDisabled ? translateFn(DISABLE_DEVICE_LIBRARY_WARNING) : warningMessage,
        defaultLanguage: language
    };
    const changeQuestion = (evaluationDocId, questionnaireId, questionnaireQuestionId, questionType) => {
        questionType === QuestionnaireEvaluationQuestionType.NEXT && photoCaptureUpdateTncAction(isTNCAccepted);
        shouldLanguageDropdownDisplay && photoCaptureUpdateFraudWarningAcceptAction(fraudWarningAccepted);
        photoCaptureResetContextAction();
        const questionGetParams = {
            companyCode,
            evaluationDocId: parseInt(evaluationDocId),
            questionnaireId: parseInt(questionnaireId),
            questionnaireQuestionId,
            questionType
        };
        questionnaireEvaluationQuestionGetAction(questionGetParams);
    };
    React.useEffect(() => {
        isSaveSuccess &&
            evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.NEXT);
    }, [isSaveSuccess]);
    React.useEffect(() => {
        if (evaluationDocId && questionnaireQuestionId && isContextUpdated) {
            let answerText = PhotoCaptureConstants.ANSWER_TEXT_DEFAULT;
            if (questionSubType === PhotoCaptureAttributeType.ACKNOWLEDGEMENT) {
                answerText = isTNCAccepted
                    ? PhotoCaptureConstants.ANSWER_TEXT_ACCEPT
                    : PhotoCaptureConstants.ANSWER_TEXT_DECLINE;
            }
            const saveQuestionParams = {
                isCacheOnly: false,
                evalId: evaluationDocId,
                coCode: companyCode,
                shouldIncludeEvalution: false,
                questionsData: [
                    {
                        qustnnrQustnId: questionnaireQuestionId,
                        answer: answerText
                    }
                ]
            };
            questionnaireEvaluationSaveRequestAction(saveQuestionParams);
        }
    }, [isContextUpdated]);
    React.useEffect(() => {
        // if shouldLanguageDropdownDisplay is true then its a welcome page
        if (!fraudWarningAccept && isFraudWarningApiStatus && shouldLanguageDropdownDisplay) {
            fraudStatement ? setIsModalOpen(true) : updateContext();
        }
    }, [fraudWarningAccept, isFraudWarningApiStatus]);
    const movePrevious = () => {
        evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.PREVIOUS);
    };
    const updateContextParams = {
        attachmentInfo: photoCaptureAttachmentInfo || [],
        documentId: evaluationDocId,
        fraudWarningAccept: `${fraudWarningAccept}`,
        isTermsAndConditionAccepted: isTNCAccepted ? PhotoCaptureConstants.Y : PhotoCaptureConstants.N,
        status: null,
        vehicle: null
    };
    const updateContext = (contextDataUpdateInput = updateContextParams) => {
        photoCaptureUpdateContextDataAction(contextDataUpdateInput, contextId, companyCode);
    };
    const moveNext = () => {
        // if shouldLanguageDropdownDisplay is true then its a welcome page
        if (shouldLanguageDropdownDisplay) {
            //User accepted the Fraud warning policy when fraudWarningAccept flag is equal to '1'
            if (fraudWarningAccept === 1 || assignmentType === PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE) {
                updateContext();
            }
            else {
                language && photoCaptureGetFraudWarningDataAction(companyCode, pbeAsgTaskId, language);
            }
        }
        else {
            updateContext();
        }
    };
    const onCheckboxClick = () => {
        setIsTNCAccepted(!isTNCAccepted);
    };
    const onIUnderstandClick = () => {
        updateContext(Object.assign(Object.assign({}, updateContextParams), { fraudWarningAccept: '1' }));
        setIsModalOpen(false);
        setFraudWarningAccepted(1);
    };
    const onModalClose = () => {
        setIsModalOpen(false);
    };
    return (React.createElement(Content, null,
        React.createElement(CarrierSectionContainer, null,
            React.createElement(WhiteLabelMobileCarrierSection, Object.assign({}, WhiteLabelMobileCarrierSectionProps))),
        questionSubType === PhotoCaptureAttributeType.ACKNOWLEDGEMENT ? (React.createElement(React.Fragment, null,
            React.createElement(CustomStyleAcknowledgeSection, null,
                React.createElement(CustomStyledCheckbox, { backgroundColor: appTheme.speechBoxBackgroundColor },
                    React.createElement(Checkbox, { id: PhotoCaptureScriptQuestionIds.ID_TNC_CHECKBOX, checked: isTNCAccepted, label: translateFn(PhotoCaptureConstants.ACCEPT_TNC), onChange: onCheckboxClick, disabled: isTermsAndConditionAccepted }))),
            React.createElement(CustomStyledActionControlsSection, null,
                !isTNCAccepted && (React.createElement(DeclineStyledDiv, { className: "declineDiv", id: PhotoCaptureScriptQuestionIds.ID_DECLINE_DIV },
                    React.createElement("span", { onClick: moveNext, role: "button" }, translateFn(PhotoCaptureConstants.I_DECLINE)))),
                React.createElement(PhotoCaptureNavigationControlComponent, { idPrefix: `${PhotoCapture.PHOTO_CAPTURE}_ScriptQuestionComponent`, buttonBackgroundColor: buttonBackgroundColor, buttonTextColor: buttonTextColor, disabledButtonBackgroundColor: disabledButtonBackgroundColor, disabledButtonTextColor: disabledButtonTextColor, shouldNextButtonDisabled: !isTNCAccepted, onLeftClick: movePrevious, onRightClick: moveNext })))) : (React.createElement(CustomStyledActionControlsSection, null,
            React.createElement(WhiteLabelMobileButton, { id: PhotoCaptureScriptQuestionIds.ID_SCRIPT_QUESTION_BUTTON, label: btnLabel, className: "mi-btn-custom-default", buttonBackgroundColor: isDeviceLibDisabled ? disabledButtonBackgroundColor : buttonBackgroundColor, buttonTextColor: isDeviceLibDisabled ? disabledButtonTextColor : buttonTextColor, isDisabled: isDeviceLibDisabled, onClick: questionSubType === PhotoCaptureAttributeType.DEFAULT ? moveNext : movePrevious }))),
        shouldLanguageDropdownDisplay && (React.createElement(LinkContainer, null,
            appTheme.termsOfUseUrl && (React.createElement(LinkButton, null,
                React.createElement("a", { target: "_blank", href: appTheme.termsOfUseUrl }, translateFn(PhotoCaptureConstants.TERMS_OF_USE)))),
            appTheme.privacyPolicyUrl && (React.createElement(LinkButton, null,
                React.createElement("a", { target: "_blank", href: appTheme.privacyPolicyUrl }, translateFn(PhotoCaptureConstants.PRIVACY_POLICY)))))),
        React.createElement(PhotoCaptureFraudWarningModal, { headerBackgroundColor: appTheme.headerBackgroundColor, footerBackgroundColor: appTheme.applicationBackgroundColor, headerColor: appTheme.headerTextColor, iUnderstandButtonBackgroundColor: appTheme.primaryButtonBackgroundColor, iUnderstandButtonTextColor: appTheme.primaryButtonTextColor, isModalOpen: isModalOpen, content: fraudStatement || '', onModalClose: onModalClose, onIUnderstandClick: onIUnderstandClick })));
};
//# sourceMappingURL=ScriptQuestionComponent.js.map